import { useEffect, useState } from 'react';
import { fetchMembers, Member, resendMemberCard } from '../services/apiClient';

export const PassesPage: React.FC = () => {
  const [members, setMembers] = useState<Member[]>([]);
  const [selectedMemberId, setSelectedMemberId] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const loadMembers = async () => {
      try {
        setLoading(true);
        const data = await fetchMembers(200);
        setMembers(data);
      } finally {
        setLoading(false);
      }
    };

    loadMembers();
  }, []);

  const onResend = async () => {
    if (!selectedMemberId) {
      setMessage('Select a member first.');
      return;
    }

    try {
      setSubmitting(true);
      setMessage(null);
      await resendMemberCard(selectedMemberId);
      const target = members.find((member) => member.id === selectedMemberId);
      setMessage(`Digital card resend queued for ${target?.fullName ?? 'member'}.`);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to resend digital card.';
      setMessage(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="passes" className="page-section">
      <div className="page-header">
        <div>
          <p className="page-eyebrow">Wallet</p>
          <h2 className="page-title">Passes</h2>
          <p className="page-copy">Issue or resend digital membership cards on demand.</p>
        </div>
      </div>

      <article className="placeholder-card">
        <h3>Resend Digital Membership Card</h3>
        <div className="member-filters">
          <select
            value={selectedMemberId}
            onChange={(event) => setSelectedMemberId(event.target.value)}
            disabled={loading || submitting}
          >
            <option value="">Select member</option>
            {members.map((member) => (
              <option key={member.id} value={member.id}>
                {member.fullName} ({member.email})
              </option>
            ))}
          </select>
          <button type="button" className="primary-action" onClick={onResend} disabled={loading || submitting}>
            {submitting ? 'Sending...' : 'Resend Card'}
          </button>
        </div>
        {message && <p className="status-loading">{message}</p>}
      </article>
    </section>
  );
};
